import { useTranslation } from "react-i18next";
import {
  CodeBlock,
  getSideDrawerContentStyles,
  InfoDrawerMeta,
  SideDrawer,
} from "@inductiveautomation/ws-components";

import IgnitionModuleLogo from "../../../../assets/images/modules/ignition.png";
import { LicenseModule } from "../../Licenses.types";
import { MODULE_DETAILS_URL } from "./Modules";

const ModulesDrawer = ({
  module,
  onClose,
}: {
  module: LicenseModule | undefined;
  onClose: () => void;
}) => {
  const { t } = useTranslation();
  const { classes: drawerClasses } = getSideDrawerContentStyles();

  return (
    <SideDrawer
      testId="maker-license-module-side-drawer"
      open={!!module}
      onClose={onClose}
      variant="modal"
      hideBackdrop
      contentSpacing="fullWidth"
      headerProps={{
        overline: t("maker_license.tabs.modules.drawer.overline"),
        heading: module?.name ?? "",
        avatarProps: {
          imageUrl: IgnitionModuleLogo,
          iconAvatarColor: "primary",
        },
        showCloseButton: true,
      }}
      footerProps={{
        actionsLabel: t("common.actions"),
        actions: [
          [
            {
              id: "view-product-details",
              label: t(
                "maker_license.tabs.modules.actions.view_product_details"
              ),
              iconLeft: "visibility",
              iconRight: "open-small",
              onClick: () => window.open(MODULE_DETAILS_URL),
            },
          ],
        ],
      }}
    >
      <InfoDrawerMeta
        heading={t("maker_license.tabs.modules.drawer.details.heading")}
        fields={[
          {
            label: t("maker_license.tabs.modules.drawer.details.description"),
            value:
              "The Ignition platform is the foundation for every Ignition system; it includes powerful features and core drivers to connect all your industrial data and devices into one central hub.",
          },
          {
            label: t("maker_license.tabs.modules.drawer.details.identifier"),
            value: "-",
          },
          {
            label: t(
              "maker_license.tabs.modules.drawer.details.current_version"
            ),
            value: module?.currentVersion ?? "[X]",
          },
          {
            label: t("maker_license.tabs.modules.drawer.details.max_version"),
            value: "[X]",
          },
          {
            label: t("maker_license.tabs.modules.drawer.details.developer"),
            value: module?.developer ?? "",
          },
        ]}
      />
      <CodeBlock
        overline={t("maker_license.tabs.modules.drawer.configuration_heading")}
        language={t("common.code_block.json")}
        className={drawerClasses.contentSectionContainer}
        code={`{
  “key”: value,
  “key”: value,
  “key”: value,
  “key”: value,
  “key”: value,
  “key”: value,
  “key”: value,
  “key”: value,
  “key”: value,
  “key”: value,
  “key”: value
}`}
      />
    </SideDrawer>
  );
};

export default ModulesDrawer;
